import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Form, Typography, Table, Button, Input, Icon, Spin, Modal, notification, DatePicker } from 'antd';
// import AddCircleIcon from '@material-ui/icons/AddCircle';
// import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
// import { green } from '@material-ui/core/colors';
import Highlighter from 'react-highlight-words';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';
import * as SignalR from '@aspnet/signalr';
import moment from 'moment';
import 'antd/dist/antd.css';

const { Title } = Typography;
const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;

@inject(
    'BookingTransactionStore'
)
@observer
class BookingTransactionListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: '',
            fromDate: undefined,
            toDate: undefined,
            roomNumber: '',
            pagination: {
                current: 1,
                pageSize: 10,
            }
        }
    }

    componentDidMount() {
        let fromDateTime = moment();
        fromDateTime.hour(0);
        fromDateTime.minute(0);
        fromDateTime.second(0);

        let toDateTime = moment();
        toDateTime.hour(23);
        toDateTime.minute(59);
        toDateTime.second(0);

        this.setState({
            fromDate: fromDateTime,
            toDate: toDateTime,
            roomNumber: ''
        }, () => {
            const { pagination } = this.state;
            this.getFilterData({ pagination });
        });

        // ---------------------------------------------------------------------------
        // SETUP SIGNAL R
        // ---------------------------------------------------------------------------

        let connection = new SignalR.HubConnectionBuilder()
            .withUrl(REACT_APP_SIGNALR_URL)
            .build();

        connection.start().catch(function (err) {
            console.error('Signal R Error in Booking Transaction Main Page');
            return console.error(err.toString());
        });

        // ---------------------------------------------------------------------------
        // SIGNAL R SYNC DATA
        // ---------------------------------------------------------------------------

        console.log(`[SignalR] Listening SignalR_SyncData to sync data from server........`);
        connection.on(`SignalR_SyncData`, () => {
            console.log('[SignalR] Received SignalR_SyncData event to sync data from server: ');
            const { pagination } = this.state;
            this.getFilterData({ pagination });
        })

        // ---------------------------------------------------------------------------
        // END UP SIGNAL R
        // ---------------------------------------------------------------------------
    }

    // Server Table Pagination

    getFilterData = (params = {}) => {
        const fromDate = moment(this.state.fromDate).format('YYYY-MM-DDTHH:mm:ss')
        const endDate = moment(this.state.toDate).format('YYYY-MM-DDTHH:mm:ss')

        this.props.BookingTransactionStore.initBookingTransaction(
            fromDate,
            endDate,
            params.pagination.current,
            params.pagination.pageSize,
            this.state.roomNumber
        ).then(() => {
            const { totalData } = this.props.BookingTransactionStore;

            this.setState({
                pagination: {
                    ...params.pagination,
                    total: totalData
                }
            })
        });
    }

    handleTableChange = (pagination, filters, sorter) => {
        this.getFilterData({
            sortField: sorter.field,
            sortOrder: sorter.order,
            pagination,
            ...filters,
        });
    }

    // ON CLICK

    createBookingTransactionOnClick = () => {
        this.props.BookingTransactionStore.initCreateBookingTransaction();
    }

    updateBookingTransactionOnClick = (id) => {
        this.props.BookingTransactionStore.initUpdateBookingTransaction(id);
    }

    deleteBookingTransactionOnClick = (id) => {
        const { t } = this.props;
        Modal.confirm({
            title: t('Delete Booking Transaction'),
            content: t('Are you sure to delete this transaction?'),
            okText: t('Yes'),
            cancelText: t('Cancel'),
            onOk: () => { this.deleteUpdateBookingTransactionOnOk(id); }
        });
    }

    // ON OK

    deleteUpdateBookingTransactionOnOk = (id) => {
        const { t } = this.props;
        this.props.BookingTransactionStore.deleteUpdateBookingTransaction(id).then(response => {
            if (response.isSuccess) {
                const { pagination } = this.state;
                this.getFilterData({ pagination });
                notification['success']({
                    message: t('Success'),
                    description: t('Booking Transaction has been successfully deleted.'),
                    duration: 3
                });
            } else {
                notification['error']({
                    message: t('Error'),
                    description: `${response.error}`,
                    duration: 3
                });
            }
        });
    }

    // TABLE SETTING

    getColumns = () => {
        const { t } = this.props;
        return [
            {
                title: t('Booking Date'),
                dataIndex: 'bookingDate',
                key: 'bookingDate',
                ...this.getColumnSearchProps('bookingDate')
            },
            {
                title: t('Room'),
                dataIndex: 'roomNumber',
                key: 'roomNumber',
                ...this.getColumnSearchProps('roomNumber')
            },
            {
                title: t('Booking By'),
                dataIndex: 'bookingBy',
                key: 'bookingBy',
                ...this.getColumnSearchProps('bookingBy')
            },
            {
                title: t('Category'),
                dataIndex: 'bookingCategoryName',
                key: 'bookingCategoryName',
                ...this.getColumnSearchProps('bookingCategoryName')
            },
            {
                title: t('Sub Category'),
                dataIndex: 'bookingSubCategoryName',
                key: 'bookingSubCategoryName',
                ...this.getColumnSearchProps('bookingSubCategoryName')
            },
            {
                title: t('Time'),
                dataIndex: 'time',
                key: 'time',
                ...this.getColumnSearchProps('time')
            },
            {
                title: t('Action'),
                dataIndex: 'id',
                key: 'id',
                render: id => (
                    <span>
                        {/* <Button onClick={() => this.updateBookingTransactionOnClick(id)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <EditIcon style={{ color: '#1890ff', fontSize: 24 }} />
                        </Button> */}
                        <Button onClick={() => this.deleteBookingTransactionOnClick(id)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <DeleteIcon style={{ color: '#DC004E', fontSize: 24 }} />
                        </Button>
                    </span>
                ),
            },
        ]
    }

    getColumnSearchProps = dataIndex => {
        const { t } = this.props;
        return {
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={node => {
                            this.searchInput = node
                        }}
                        placeholder={t(`Search ${dataIndex}`)}
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Button
                        type='primary'
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon='search'
                        size='small'
                        style={{ width: 90, marginRight: 8 }}
                    >
                        {t('Search')}
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size='small' style={{ width: 90 }}>
                        {t('Reset')}
                    </Button>
                </div>
            ),
            filterIcon: filtered => (
                <Icon type='search' style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
            onFilter: (value, record) =>
                record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => this.searchInput.select())
                }
            },
            render: text =>
                this.state.searchedColumn === dataIndex ? (
                    <Highlighter
                        highlightStyle={{ padding: 0 }}
                        searchWords={[this.state.searchText]}
                        autoEscape
                        textToHighlight={text.toString()}
                    />
                ) : (
                    text
                ),
        }
    };

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    fromDateChange = (e) => {
        this.setState({
            fromDate: e
        })
    }

    toDateChange = (e) => {
        this.setState({
            toDate: e
        })
    }

    roomNumberChange = (e) => {
        this.setState({
            roomNumber: e.target.value
        })
    }

    searchData = () => {
        const { pagination } = this.state;
        this.getFilterData({ pagination });
    }

    render() {
        const { t } = this.props;
        const {
            bookingTransactions,
            bookingTransactionListLoading
        } = this.props.BookingTransactionStore;

        const { pagination } = this.state;

        return (
            <React.Fragment>
                <Form layout='horizontal'>
                    <div style={{ marginBottom: 20 }}>
                        <Title level={3}>{t('List')}</Title>
                        {/* <div style={{ textAlign: 'right' }}>
                            <button type='button' style={{ border: 'none', background: 'none', cursor: 'pointer' }} onClick={this.createBookingTransactionOnClick}>
                                <AddCircleIcon style={{ color: green[500], fontSize: 45 }} />
                            </button>
                        </div> */}
                        <div style={{ display: 'flex', alignItems: 'center', height: 48 }}>
                            <div style={{ paddingRight: 8 }}>{t('From Date')}</div>
                            <div style={{ paddingRight: 16 }}>
                                <DatePicker
                                    format='YYYY/MM/DD'
                                    value={this.state.fromDate}
                                    onChange={(e) => this.fromDateChange(e)}
                                />
                            </div>
                            <div style={{ paddingRight: 8 }}>{t('To Date')}</div>
                            <div style={{ paddingRight: 16 }}>
                                <DatePicker
                                    format='YYYY/MM/DD'
                                    value={this.state.toDate}
                                    onChange={(e) => this.toDateChange(e)}
                                />
                            </div>
                            <div style={{ paddingRight: 8 }}>{t('Room Number')}</div>
                            <div style={{ paddingRight: 16 }}>
                                <Input value={this.state.roomNumber} placeholder={t('Room Number')} onChange={this.roomNumberChange} />
                            </div>
                            <div>
                                <Button onClick={this.searchData}>{t('Search')}</Button>
                            </div>
                        </div>
                    </div>
                    <Spin spinning={bookingTransactionListLoading}>
                        <Table
                            columns={this.getColumns()}
                            rowKey={record => record.id}
                            dataSource={bookingTransactions}
                            pagination={pagination}
                            onChange={this.handleTableChange} />
                    </Spin>
                </Form>
            </React.Fragment>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(BookingTransactionListPage);
